import React, { useState, useEffect } from "react";

import { ResultProvider } from "../../dataProvider/results";
import { getResultOrigin } from "../../dataProvider/origin";
import { TYPES, SUBTYPES } from "../../envs/core";

import Header from "../../components/header";
import AtresPieChart from "../../components/charts/atresPieChart";

const ChartCompare = ({ match }) => {
  const {
    year,
    type,
    electionNumber,
    placesIds,
    province,
    community
  } = match.params;

  const [resultOrigin, setResultOrigin] = useState({});

  useEffect(() => {
    getResultOrigin(year, type, electionNumber, placesIds)
      .then(historicResult => {
        setResultOrigin(historicResult);
      })
      .catch(err => {});
  }, [year, type, electionNumber]);

  return (
    <div className="ChartComparePage">
      {!province && !community && (
        <Header>
          <h2>ASÍ QUEDA EL CONGRESO</h2>
        </Header>
      )}
      {resultOrigin && resultOrigin.primary && (
        <ResultProvider
          active={resultOrigin.primary.active}
          year={year}
          type={type}
          subtype={type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE}
          electionNumber={electionNumber}
          electionPlace={placesIds}
          placeId={province || community}
        >
          {dataResult => (
            <ResultProvider
              active={resultOrigin.historic.active}
              year={resultOrigin.historic.year}
              type={type}
              subtype={
                type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE
              }
              electionNumber={resultOrigin.historic.numElection}
              electionPlace={placesIds}
              placeId={province || community}
            >
              {oldData =>
                dataResult.partiesResult ? (
                  console.log(dataResult.partiesResult),
                  <div className="ChartCompareWrapper">
                    <AtresPieChart
                      data={dataResult.partiesResult || []}
                      data2={oldData.partiesResult || []}
                      dataKey={"votesPercent"}
                      showLabel={
                        type !== TYPES.REGIONAL
                          ? !province && !community
                          : !Boolean(province)
                      }
                      seatTotal={dataResult.totalSeats || 0}
                    />
                  </div>
                ) : (
                  <p>Cargando...</p>
                )
              }
            </ResultProvider>
          )}
        </ResultProvider>
      )}
    </div>
  );
};

export default ChartCompare;
